import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Datas from '../../data/shop/mondiya/product.json';
import HeaderTwo from '../../components/mondiya/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/mondiya/Breadcrumb';
import FooterTwo from '../../components/mondiya/FooterTwo';
import { Styles } from './styles/quote.js';
import emailjs from 'emailjs-com';
import { useLocation } from 'react-router-dom';
import {useTranslation} from 'react-i18next';

function Quote() {
    const { t } = useTranslation();
    const [groupedProducts, setGroupedProducts] = useState({});
    const location = useLocation();

    useEffect(() => {
        const form = document.getElementById("form_registration");
        const fname = document.getElementById("fname");
        const productname = document.getElementById("product_name");
        const email = document.getElementById("email");
        const phone = document.getElementById("phone");
        const message = document.getElementById("message");
        const honeypot = document.querySelector('input[name="company_website"]');

        if (!form) return;

        form.addEventListener("submit", formSubmit);

        // Group products by category_name
        const groupByCategory = (products) => {
            return products.reduce((acc, product) => {
                const category = product.category_name;
                if (!acc[category]) {
                    acc[category] = [];
                }
                acc[category].push(product);
                return acc;
            }, {});
        };

        setGroupedProducts(groupByCategory(Datas));

        function formSubmit(e) {
            e.preventDefault();

            const fnameValue = fname.value.trim();
            const productnameValue = productname.value.trim();
            const emailValue = email.value.trim();
            const phoneValue = phone.value.trim();
            const messageValue = message.value.trim();

            // Honeypot check (bot submissions)
            if (honeypot && honeypot.value) {
                return; // silently block bots
            }

            // Validate fields
            if (fnameValue === "") {
                setError(fname, "Full name can't be blank");
            } else {
                setSuccess(fname);
            }

            if (productnameValue === "") {
                setError(productname, "Please select a product");
            } else {
                setSuccess(productname);
            }

            if (emailValue === "") {
                setError(email, "Email can't be blank");
            } else if (!isEmail(emailValue)) {
                setError(email, "Not a valid email");
            } else {
                setSuccess(email);
            }

            if (phoneValue === "") {
                setError(phone, "Phone number can't be blank");
            } else if (!isPhoneNumber(phoneValue)) {
                setError(phone, "Not a valid phone number");
            } else {
                setSuccess(phone);
            }

            if (messageValue === "") {
                setError(message, "Message can't be blank");
            } else {
                setSuccess(message);
            }

            // If no errors, send the email via EmailJS
            if (
                fnameValue &&
                productnameValue &&
                emailValue &&
                phoneValue &&
                messageValue &&
                isEmail(emailValue) &&
                isPhoneNumber(phoneValue)
            ) {
                const selectedProduct = Datas.find(p => p.productTitle === productnameValue);
                const sanitize = (s) =>
                    s.replace(/[^a-zA-Z0-9-]+/g, ' ')
                        .replace(/\s+/g, ' ')
                        .trim();

                const finalProductName = sanitize(
                    `${selectedProduct ? selectedProduct.category_name : ''} - ${selectedProduct ? selectedProduct.productTitle : productnameValue}`
                );

                const originalNameAttr = productname.getAttribute('name');
                productname.setAttribute('name', 'product_name_original');

                const hiddenProductName = document.createElement('input');
                hiddenProductName.type = 'hidden';
                hiddenProductName.name = 'product_name';
                hiddenProductName.value = finalProductName;
                form.appendChild(hiddenProductName);

                emailjs
                    .sendForm(
                        'service_psjkhj3',
                        'template_2t6iste',
                        form,
                        'tAiy3dVRCDbQqBcT2'
                    )
                    .then(
                        () => {
                            alert("Message Sent Successfully!");
                            form.reset();

                            // Restore product_name field
                            productname.setAttribute('name', originalNameAttr);
                            if (hiddenProductName && hiddenProductName.parentNode) {
                                hiddenProductName.parentNode.removeChild(hiddenProductName);
                            }
                        },
                        () => {
                            alert("Error sending message. Please try again.");
                            // Restore product_name field
                            productname.setAttribute('name', originalNameAttr);
                            if (hiddenProductName && hiddenProductName.parentNode) {
                                hiddenProductName.parentNode.removeChild(hiddenProductName);
                            }
                        }
                    );
            }
        }

        function setError(input, message) {
            const formControl = input.parentElement;
            const errorMsg = formControl.querySelector(".registration_input-msg");
            formControl.className = "form-control text-left error";
            errorMsg.innerText = message;
        }

        function setSuccess(input) {
            const formControl = input.parentElement;
            formControl.className = "form-control success";
        }

        function isEmail(email) {
            return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);
        }

        function isPhoneNumber(phone) {
            return /^[0-9]{10,15}$/.test(phone);
        }

        // Optional: cleanup listener on unmount
        return () => {
            form.removeEventListener("submit", formSubmit);
        };
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const slug = params.get('slug');
        if (!slug) return;

        const matched = Datas.find(p => p.product_slug === slug);
        if (!matched) return;

        const selectEl = document.getElementById("product_name");
        if (selectEl) {
            selectEl.value = matched.productTitle;
        }
    }, [groupedProducts, location.search]);

    return (
        <Styles>
            <div className="main-wrapper registration-page">
                <HeaderTwo />
                <BreadcrumbBox title={t(`quoteForm.breadcrumbs`)} />

                <section className="registration-area">
                    <Container>
                        <Row>
                            <Col md="12">
                                <div className="registration-box">
                                    <div className="registration-title text-center">
                                        <h3>{t(`quoteForm.qTitle`)}</h3>
                                    </div>
                                    <form id="form_registration" className="form">
                                        <p className="form-control">
                                            <label htmlFor="fname">{t(`quoteForm.qName`)}</label>
                                            <input type="text" placeholder="Full name" id="fname" name="fname" />
                                            <span className="registration_input-msg"></span>
                                        </p>

                                        <p className="form-control">
                                            <label htmlFor="email">{t(`quoteForm.qEmail`)}</label>
                                            <input type="email" placeholder="Email address" id="email" name="email" />
                                            <span className="registration_input-msg"></span>
                                        </p>

                                        <p className="form-control">
                                            <label htmlFor="phone">{t(`quoteForm.qPhone`)}</label>
                                            <input type="text" placeholder="Phone number" id="phone" name="phone" />
                                            <span className="registration_input-msg"></span>
                                        </p>

                                        <p className="form-control">
                                            <label htmlFor="product_name">{t(`quoteForm.qProduct`)}</label>
                                            <select id="product_name" name="product_name">
                                                <option value="">Select Product</option>
                                                {Object.keys(groupedProducts).map((categoryName) => (
                                                    <optgroup label={categoryName} key={categoryName}>
                                                        {groupedProducts[categoryName].map((product) => (
                                                            <option key={product.id} value={product.productTitle}>
                                                                {product.productTitle} ({product.anotherName})
                                                            </option>
                                                        ))}
                                                    </optgroup>
                                                ))}
                                            </select>
                                            <span className="registration_input-msg"></span>
                                        </p>

                                        <p className="form-control">
                                            <label htmlFor="message">{t(`quoteForm.qMessage`)}</label>
                                            <textarea
                                                id="message"
                                                name="message"
                                                rows="10"
                                                placeholder="Enter your message"
                                            />
                                            <span className="registration_input-msg"></span>
                                        </p>

                                        {/* Honeypot field (kept for bot protection) */}
                                        <p className="form-control" style={{ display: 'none' }}>
                                            <input
                                                type="text"
                                                name="company_website"
                                                tabIndex="-1"
                                                autoComplete="off"
                                            />
                                            <span className="registration_input-msg"></span>
                                        </p>

                                        <button type="submit">{t(`quoteForm.qSubmit`)}</button>
                                    </form>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                <FooterTwo />
            </div>
        </Styles>
    );
}

export default Quote;